export default __webpack_public_path__ + "static/media/book-employee.61805fe2.svg";